// extracted by mini-css-extract-plugin
export default {"base-layout__overlay":"PendingDialog-dkAPK__base-layout__overlay"};